import { styled } from '@mui/system';
import Pagination from '@mui/material/Pagination';

export const StyledPagination = styled(Pagination)(({ theme }) => ({
  paddingBottom: theme.spacing(3),
  [theme.breakpoints.down('md')]: {
    paddingTop: theme.spacing(2)
  },
  '& > ul': {
    justifyContent: 'center'
  }
}));

export const PaginationPlaceholder = styled('div')(() => ({
  height: 1
}));
